document.addEventListener("DOMContentLoaded", () => {
  const sections = document.querySelectorAll(".collection-tabs-section");
  if (!sections.length) return;

  sections.forEach((sectionElement) => {
    const tabButtons = sectionElement.querySelectorAll(".js-tab-btn");
    const carousels = sectionElement.querySelectorAll(".js-tab-carousel");

    const emblaInstances = {};

    const initCarouselForTab = (carouselNode) => {
      const tabId = carouselNode.getAttribute("data-tab-id");
      const emblaNode = carouselNode.querySelector(".embla");
      if (!emblaNode) return;

      const viewportNode = emblaNode.querySelector(".embla__viewport");
      const dotsNode = carouselNode.querySelector(".embla__dots");
      const prevButton = carouselNode.querySelector(".embla__button--prev");
      const nextButton = carouselNode.querySelector(".embla__button--next");

      const options = {
        align: "start",
        containScroll: "trimSnaps",
        dragFree: false
      };

      const embla = EmblaCarousel(viewportNode, options);
      emblaInstances[tabId] = embla;

      let dots = [];
      const scrollSnaps = embla.scrollSnapList();

      if (dotsNode && scrollSnaps.length > 1) {
        dotsNode.innerHTML = scrollSnaps.map((_, i) => `<button class="embla__dot" type="button" aria-label="Go to slide ${i + 1}"></button>`).join("");
        dots = Array.from(dotsNode.querySelectorAll(".embla__dot"));
        dots.forEach((dot, index) => {
          dot.addEventListener("click", () => embla.scrollTo(index));
        });

        const updateDots = () => {
          const selected = embla.selectedScrollSnap();
          dots.forEach((dot, index) => {
            if (index === selected) {
              dot.classList.add("active");
            } else {
              dot.classList.remove("active");
            }
          });
        };
        embla.on("select", updateDots);
        updateDots();
      }

      if (prevButton) {
        prevButton.addEventListener("click", () => embla.scrollPrev());
      }
      if (nextButton) {
        nextButton.addEventListener("click", () => embla.scrollNext());
      }
    };

    const activeCarousel = sectionElement.querySelector(".js-tab-carousel:not([style*='display: none'])");

    if (activeCarousel) {
      initCarouselForTab(activeCarousel);
    }

    tabButtons.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        const tabId = btn.getAttribute("data-tab-id");

        tabButtons.forEach((b) => {
          b.classList.remove("esc-button--active");
          b.classList.add("esc-button--secondary");
        });
        btn.classList.add("esc-button--active");
        btn.classList.remove("esc-button--secondary");

        carousels.forEach((carousel) => {
          if (carousel.getAttribute("data-tab-id") === tabId) {
            carousel.style.display = "block";
            if (!emblaInstances[tabId]) {
              initCarouselForTab(carousel);
            } else {
              emblaInstances[tabId].reInit();
            }
          } else {
            carousel.style.display = "none";
          }
        });
      });
    });

    window.addEventListener("resize", () => {
      Object.keys(emblaInstances).forEach((key) => {
        if (emblaInstances[key]) {
          emblaInstances[key].reInit();
        }
      });
    });
  });
});
